/* 新版集合页与 Sale 页共用外壳的导航控制器（2026-10-20 PG-SALE-1020-A0 自 pg-collection-experience.js 搬出，逻辑未改）。
   只在 body.pg-cv2-chrome 页工作（开关见 layout/theme.liquid）；状态写在 body[data-cv2-nav]，样式见 assets/pg-cv2-chrome.css。
   页面内容换断点后需要重算导航时，派发 document 事件 'pg-cv2:nav-update'（集合页 960 重排商品时用）。 */
(() => {
  if (window.pgCv2ChromeLoaded) return;
  window.pgCv2ChromeLoaded = true;

  function start() {
    const body = document.body;
    if (!body.classList.contains('pg-cv2-chrome')) return;
    // 导航按主题断点 990 切换手机/桌面（与页面内容的 960 断点不同）。
    const mobileNav = window.matchMedia('(max-width: 989px)');
    let navState = '';
    let lastScrollY = window.scrollY;
    let navFrame = 0;

    function setNavState(state) {
      if (state === navState) return;
      const instant = navState === 'top' || state === 'top' || !navState;
      body.toggleAttribute('data-cv2-nav-instant', instant);
      body.dataset.cv2Nav = state;
      navState = state;
      if (instant) requestAnimationFrame(() => requestAnimationFrame(() => body.removeAttribute('data-cv2-nav-instant')));
    }

    function updateNav() {
      const y = window.scrollY;
      const down = y > lastScrollY;
      lastScrollY = y;
      const header = document.querySelector('.section-header');
      // 公告条28 + 导航70：未滚出这段时导航随页面在公告条下方；滚出后下滑隐藏、上滑白底显示。
      // y<=28：absolute 与 fixed 位置重合，才无缝切回 top；28~98 上滑保持 shown，避免 y=98 处导航瞬间消失。
      let state;
      if (mobileNav.matches || !header || y <= 28) state = 'top';
      else if (y <= 98 && (navState === 'top' || !navState)) state = 'top';
      else state = down || navState === 'top' || !navState ? 'hidden' : 'shown';
      setNavState(state);
    }

    function prepareNavigation() {
      // 配置保留；仅外壳页按稿显示六项和对应顺序（Sale 紧跟 TV Carts，PG-SALE-1020-R1）。
      // Sale 入口运营会按活动改名（10-27 改成「🎃 Halloween」后匹配不上、被排到最前），改按链接 /pages/sale 认。
      const mapping = new Map([['TV Stands', 1], ['TV Mounts', 2], ['TV Carts', 3], ['Explore&Brand', 5], ['Support&Service', 6]]);
      document.querySelectorAll('.header_menu_item').forEach((item) => {
        const link = item.querySelector('.header_menu_item_text');
        const name = link?.textContent.trim();
        const href = link?.getAttribute('href');
        const isSale = !!href && new URL(href, location.origin).pathname.replace(/\/$/, '').endsWith('/pages/sale');
        if (name === 'AI Adaptive Mount') item.dataset.cv2NavHidden = '';
        else if (isSale) item.dataset.cv2NavOrder = 4;
        else if (mapping.has(name)) item.dataset.cv2NavOrder = mapping.get(name);
      });
    }

    window.addEventListener('scroll', () => {
      if (navFrame) return;
      navFrame = requestAnimationFrame(() => { navFrame = 0; updateNav(); });
    }, { passive: true });
    mobileNav.addEventListener('change', updateNav);
    document.addEventListener('pg-cv2:nav-update', updateNav);
    // 导航收起时 Tab 聚焦到头部链接：切回 shown，焦点才看得见。
    document.querySelector('.section-header')?.addEventListener('focusin', () => {
      if (navState === 'hidden') setNavState('shown');
    });
    updateNav();
    prepareNavigation();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
